import { IconType } from '@factorialco/f0-react'
import {
  Bank as BankIcon,
  Bell as BellIcon,
  BookOpen as BookOpenIcon,
  CheckCircleLine as CheckCircleLineIcon,
  Clock as ClockIcon,
  Folder as FolderIcon,
  Graph as GraphIcon,
  Megaphone as MegaphoneIcon,
  MoneyBag as MoneyBagIcon,
  Money as MoneyIcon,
  PalmTree as PalmTreeIcon,
  Receipt as ReceiptIcon,
  SearchPerson as SearchPersonIcon,
  Suitcase as SuitcaseIcon,
  Wallet as WalletIcon,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

// eslint-disable-next-line factorial/no-unhealthy-enums
enum NotifierCategory {
  Timeoff = 'Timeoff',
  Attendance = 'Attendance',
  Ats = 'Ats',
  Contracts = 'Contracts',
  Documents = 'Documents',
  Esignature = 'Esignature',
  Expenses = 'Expenses',
  Banking = 'Banking',
  Tasks = 'Tasks',
  Procurement = 'Procurement',
  Payroll = 'Payroll',
  IntegrationsDatevLauds = 'IntegrationsDatevLauds',
  BookkeepersManagement = 'BookkeepersManagement',
  ProductUpdates = 'ProductUpdates',
  Trainings = 'Trainings',
  ProjectManagement = 'ProjectManagement',
  Processes = 'Processes',
  Upsell = 'Upsell',
  Finance = 'Finance',
  Performance = 'Performance',
}

export const getCategoryAndIcon = (notifier: string): { category: string; icon?: IconType } => {
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const firstPart = notifier.split('::')?.[0] as NotifierCategory

  switch (firstPart) {
    case NotifierCategory.Timeoff:
      return { category: i18n.t('sidebar.time_off'), icon: PalmTreeIcon }
    case NotifierCategory.Attendance:
      return { category: i18n.t('sidebar.clock_in'), icon: ClockIcon }
    case NotifierCategory.Ats:
      return { category: i18n.t('sidebar.recruitment'), icon: SearchPersonIcon }
    case NotifierCategory.Contracts:
      return { category: i18n.t('sidebar.contracts'), icon: BellIcon }
    case NotifierCategory.Documents:
    case NotifierCategory.Esignature:
      return { category: i18n.t('sidebar.documents'), icon: FolderIcon }
    case NotifierCategory.Expenses:
      return { category: i18n.t('sidebar.expenses_v2'), icon: MoneyBagIcon }
    case NotifierCategory.Banking:
      return { category: i18n.t('sidebar.finance_treasury'), icon: BankIcon }
    case NotifierCategory.Tasks:
    case NotifierCategory.Processes:
      return { category: i18n.t('tasks.header'), icon: CheckCircleLineIcon }
    case NotifierCategory.Procurement:
      return { category: i18n.t('sidebar.purchases'), icon: WalletIcon }
    case NotifierCategory.Payroll:
    case NotifierCategory.BookkeepersManagement:
    case NotifierCategory.IntegrationsDatevLauds:
      return { category: i18n.t('sidebar.payroll_bundle'), icon: MoneyIcon }
    case NotifierCategory.ProductUpdates:
      return { category: i18n.t('sidebar.product_updates.news'), icon: MegaphoneIcon }
    case NotifierCategory.Trainings:
      return { category: i18n.t('sidebar.trainings'), icon: BookOpenIcon }
    case NotifierCategory.ProjectManagement:
      return { category: i18n.t('sidebar.projects_management'), icon: SuitcaseIcon }
    case NotifierCategory.Upsell:
      return { category: i18n.t('sidebar.marketplace'), icon: MegaphoneIcon }
    case NotifierCategory.Finance:
      return { category: i18n.t('sidebar.finance'), icon: ReceiptIcon }
    case NotifierCategory.Performance:
      return { category: i18n.t('sidebar.performance_new'), icon: GraphIcon }
    default:
      return { category: i18n.t('common.unknown') }
  }
}

// Helper function to convert full URLs to relative paths for React Router
export const getRelativePath = (url: string): string => {
  try {
    const urlObj = new URL(url)
    return urlObj.pathname + urlObj.search + urlObj.hash
  } catch {
    // If URL parsing fails, assume it's already a relative path
    return url
  }
}
